import { IOfferDescription } from "./IOfferDescription";
import { OfferDescriptionAutoAccept } from "./OfferDescriptionAutoAccept";
import { OfferDescriptionCostC1 } from "./OfferDescriptionCostC1";
import { OfferDescriptionCostC2 } from "./OfferDescriptionCostC2";

import { Constants_Offer } from "../Constants_Offer";
import { IPrivateOfferModel } from "../offerQuestConditions/IPrivateOfferModel";

export class BasicOfferDescriptionFactory {
    protected modelData: IPrivateOfferModel;

    constructor(model: IPrivateOfferModel) {
        this.modelData = model;
    }

    /**
     * creates an OfferDescription
     * can be overriden to varriat the creation process
     * @param name
     * @param params
     * @return
     */
    public createOfferDescriptionObject(name: string, params: any): IOfferDescription {

        let finalProduct: IOfferDescription;

        switch (name) {
            case Constants_Offer.OFFER_AUTO_ACCEPT:
                finalProduct = new OfferDescriptionAutoAccept(params);
                break;
            case Constants_Offer.OFFER_COST_C1:
                finalProduct = new OfferDescriptionCostC1(Number(params));
                break;
            case Constants_Offer.OFFER_COST_C2:
                finalProduct = new OfferDescriptionCostC2(Number(params));
                break;
            default:
                break;
        }

        return finalProduct;
    }

    public dispose(): void {
        this.modelData = null;
    }
}

